/** Exemplos estáticos para cadastro admin (espelham fixture do portal). */

export const NOVIDADES_CONTENT_MINIMAL_EXAMPLE = `🏷️ Etiquetas ainda mais inteligentes:
Agora você define se a categoria de etiqueta vale por conversa ou por cliente. Mais precisão nos atendimentos.`;

export const NOVIDADES_CONTENT_SHORT_EXAMPLE = `🏷️ Etiquetas ainda mais inteligentes:
Agora você define se a categoria de etiqueta vale por conversa ou por cliente. Mais precisão e organização nos atendimentos.

🖼️ Imagens sempre atualizadas:
O processador identifica mudanças e atualiza as imagens automaticamente. [Clique Aqui](https://lifeapps.com.br/suporte) para agendar a instalação.

🔐 Permissão para submissão de pedidos: ([Acessar Artigo](https://ajuda.lifeapps.com.br/permissoes))
Defina quem pode enviar pedidos no sistema, com mais controle e segurança.`;
